module.exports = __webpack_public_path__ + "img/orange-and-yellow-lily.387ae338.jpg";